import React from "react";

import {ISurpriseCreation} from "../../types/ISurpriseCreation";
import {reportCreation} from "../creation_analytics";
import {SurpriseCreationDisplay} from "./SurpriseCreationDisplay";

interface ISurpriseCreationProps {
    creation: ISurpriseCreation;
    url: string;
    metadata: {sas_id: string; position: number};
    referenceElementId?: string;
}

export const SurpriseCreation = (props: ISurpriseCreationProps) => {
    const {
        metadata: {sas_id},
        creation,
        url,
        referenceElementId
    } = props;

    const reportData = {
        box_name: sas_id,
        position: props.metadata.position,
        ad_name: props.creation.name
    };

    return (
        <SurpriseCreationDisplay
            creation={creation}
            url={url}
            htmlElementId={sas_id}
            onElementActive={() => {
                reportCreation.gtm.surpriseAdViewed(reportData);
            }}
            onCreationClick={() => {
                reportCreation.gtm.surpriseAdRedirectionClick(reportData);
            }}
            onBackfaceClick={() => {
                reportCreation.gtm.surpriseAdRevealed(reportData);
            }}
            referenceElementId={referenceElementId}
        />
    );
};
